import React, { SVGProps } from 'react'

export const HorseToySvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.446 7.113c-.817.453-.667 1.78-.49 2.388.327 1.398.74 4.506 1.019 6.598l.05.383a11.93 11.93 0 0 0 1.242-1.162 1 1 0 1 1 1.466 1.36C19.271 19.337 15.825 21 12 21c-3.824 0-7.271-1.663-9.734-4.32a1 1 0 0 1 1.468-1.36c.534.577 1.12 1.097 1.75 1.553l.939-5.827c.107-.666-.501-1.208-.959-.712-.488.53-.74 1.286-.847 1.9-.05.29-.317.513-.602.438-1.699-.446-2.057-1.697-2.01-2.439a.405.405 0 0 1 .14-.279C3.481 8.787 5.87 8.516 6.925 8.53h5.537c.552 0 1.002-.45 1.096-.993.161-.935.552-2.167 1.374-3.094 1.242-1.4 3.588-1.879 4.929-.997a4.35 4.35 0 0 1 1.594.195c.19.062.16.32-.033.374a7.38 7.38 0 0 0-.807.273c.742 1.305.908 3 .895 3.716-.523.713-1.117.648-1.348.526a9.417 9.417 0 0 1-.055-.136c-.232-.578-.722-1.801-1.66-1.28ZM7.653 18.105C8.998 18.683 10.465 19 12 19c1.803 0 3.513-.437 5.04-1.221-.285-1.57-1.35-3.936-4.92-3.88-3.785.06-4.303 2.58-4.467 4.206Z"
      clipRule="evenodd"
    />
  </svg>
)
